import Router from './router/index';
import 'antd/dist/antd.less';
import { AliveScope } from 'react-activation';
function App() {
  return <AliveScope>
    <Router />
  </AliveScope>;
}

export default App;
